<template>
	<div class="location-edit" v-if="location">
		<div class="row">
			<div class="col-12">
				<div class="alert alert-info">
					This location is associated with 
					<router-link class="btn btn-primary btn-inline" target="_blank" :to="{ path: '/data/checklists/', query: { filterqs: '|locations:' + location.id }}"><i class="fa fa-external-link"></i> {{location.meta.total_checklists}} checklist(s)</router-link>
					and 
					<router-link class="btn btn-primary btn-inline" target="_blank" :to="{ path: '/data/records/', query: { filterqs: '|locations:' + location.id }}"><i class="fa fa-external-link"></i> {{location.meta.total_sightings}} record(s)</router-link>
					.<br />Editing this location will change the information for all of these entries.
				</div>
			</div>
			<div class="col-md-6">
				<label>Name</label>
				<input v-model="location.name" type="text" />
				<ErrorField :errors="api_errors" field="name" />

				<label>Description</label>
				<textarea v-model="location.description" />
				<ErrorField :errors="api_errors" field="description" />

		        <label>Latitude:</label>
		        <input class="validate-required" type="text" v-model="location.latitude" placeholder="Latitude" />
		        <ErrorField :errors="api_errors" field="latitude" />
		        <label>Longitude:</label>
		        <input class="validate-required" type="text" v-model="location.longitude" placeholder="longitude" />
		        <ErrorField :errors="api_errors" field="longitude" />
		        <label>Private Property:</label><br />
	            <div class="input-checkbox">
	              <input type="checkbox" v-model="location.private_property" />
	              <label for="checkbox"></label>
	            </div>
		        <ErrorField :errors="api_errors" field="private_property" />
			</div>
			<div class="col-md-6">
	            <GmapMap
	            	v-if="marker_position"
	                ref="ocLocationMap"
	                id="ocLocationMap"
	                :center="marker_position"
			      	:zoom="10"
			      	:options="mapOptions"
			      	style="min-height:600px;"
			      	@click="setLatLng"
			      >
			      <GmapMarker ref="locationMarker" :position="marker_position" />
			    </GmapMap>
		        <div v-if="zoom < 10" class="alert alert-info">
		          Please zoom in further to set a location point.
		        </div>
			</div>
		</div>
		<br />
		<div class="row">
			<div class="col-md-12" style="margin-bottom:7px;">
				<button @click="editSave()" class="btn btn-block btn-primary">Save</button>
			</div>
			<div class="col-md-6">
				<button @click="editCancel()" class="btn btn-block">Cancel</button>
			</div>
			<div class="col-md-6" v-if="location.meta.total_checklists == 0 && location.meta.total_sightings == 0">
				<button @click="editDelete()" class="btn btn-block btn-danger">Delete</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LocationEdit',
		props: ['value'],
		data: function(){
			return {
      			zoom: 10,
				location: this.value ? this.value : null,
				api_errors:{},
				mapOptions: {
	                zoomControl: true,
	                mapTypeControl: true,
	                scaleControl: false,
	                streetViewControl: false,
	                rotateControl: false,
	                fullscreenControl: true,
	            },
			};
		},
		mounted: function(){
			var self = this;
			this.$refs.ocLocationMap.$mapPromise.then((map) => {
		      this.$refs.ocLocationMap.$on('zoom_changed', function(){
		        self.zoom = map.getZoom();
		      });
		    });
		    if (this.location && this.location.name == "") {
		    	this.location.name = this.location.display_name;
		    }
		},
		methods:{
			setLatLng: function(event){
		      this.$refs.ocLocationMap.$mapPromise.then((map) => {
		        if (map.getZoom() >= 10) {
		          this.location["latitude"] = event.latLng.lat().toFixed(7);
		          this.location["longitude"] = event.latLng.lng().toFixed(7);
		        }
		      })
		    },
			getPatchData: function(){
				return {
					name: this.location.name,
					description: this.location.description,
					latitude: this.location.latitude,
					longitude: this.location.longitude,
					private_property: this.location.private_property,
				};
			},
			editSave: function(){
				var self = this;
				this.API({
	                endpoint: 'locations/' + self.location.id,
	                isPatch:true,
	                postData: self.getPatchData(),
	                funcThen: function(response){
            			self.$notify({
							text: 'Loction Saved',
							type: 'success',
						});
	                    self.$emit('saved', self.location);
	                },
	                funcCatch: function(error){
	                	if (error.response) {
	                    	self.api_errors = error.response.data;
	                	}
	                	else{
	                		this.$notify({
								text: 'There was an error saving your location.',
								type: 'error',
							});
	                	}
	                },
	            });
			},
			editCancel: function(){
				this.location = null;
				this.$emit('canceled');
			},
			editDelete: function(){
				if (!confirm("Are you sure you want to delete this location?")) {
					return;
				}
				var self = this;
				this.API({
	                endpoint: 'locations/' + self.location.id,
	                isDelete:true,
	                funcThen: function(response){
            			self.$notify({
							text: 'Loction Deleted',
							type: 'success',
						});
	                    self.$emit('saved', self.location);
	                },
	            });
			},
			bindCounts: function(){

			},
		},
		watch: {
			location:function(val){
				this.location = val;
				if (this.location.name == "") {
					this.location.name = this.location.display_name;
				}
				this.bindCounts();
			},
			location: function () {
				this.$emit('input', this.location);
			},
		},
	    computed: {
		      marker_position:{
		          get: function(){
		              if (this.location.latitude == null || this.location.longitude == null) {
		                return null;
		              }
		              var lat = this.location.latitude;
		              var lng = this.location.longitude;
		              return {
		              	lat: typeof lat === 'string' ? parseFloat(lat) : lat, 
		              	lng: typeof lng === 'string' ? parseFloat(lng) : lng
		              };
		          }
		      },
	    },
	}
</script>


// WEBPACK FOOTER //
// src/components/LocationEdit.vue